/*=========================================================================================
  File Name: modulePaymentPlan.js
  Description: Partner Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./modulePaymentPlanState.js";
import mutations from "./modulePaymentPlanMutations.js";
import actions from "./modulePaymentPlanActions.js";
import getters from "./modulePaymentPlanGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
